<style lang="scss" scoped>
::v-deep textarea {
    min-height: 108px !important;
    height: 108px !important;
}
</style>

<template>
    <div class="contact-form">
        <h2 class="md:text-h2 text-h3 mb-24 font-bold" v-html="translations.title"></h2>
        <el-form button-class="btn btn-green btn-sm btn-rounded font-bold" @submit="submit" :loading="loading" :success="success" :error="server_error" :submit-text="translations.send">
            <el-input v-model="formData.name" rules="required" :label="translations.name" class="mb-16"></el-input>
            <el-input v-model="formData.email" rules="required|email" :label="translations.email" class="mb-16"></el-input>
            <el-input v-model="formData.phone" rules="required" :label="translations.phone" class="mb-16"></el-input>
            <el-input v-model="formData.description" rules="required" :label="translations.message" type="textarea" class="mb-24"></el-input>
        </el-form>
    </div>
</template>

<script>
import hasForm from "@/mixins/components/has-form";

export default {
    name: "Forms.ContactForm",

    mixins: [hasForm],

    props: {
        translations: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            formData: {
                name: "",
                email: "",
                phone: "",
                description: ""
            }
        };
    },

    methods: {
        submit() {
            this.beforeSubmit();

            axios
                .post("/api/contact", this.formData)
                .then(response => {
                    this.handleSuccess();
                })
                .catch(e => this.handleError(e));
        }
    }
};
</script>
